module.exports = __webpack_public_path__ + "media/customizations/spanishpeaks/back-0a7d74ded90a3f0969c9abe497df0d29.jpg";